<style scoped>
    .rightSelect {
        width:100px;
    }
</style>
<template>
    <div style="position: relative; " id="layout-container-hui">

        <Form :label-width="100">
            <FormItem>
                <p  style="color:#28EDF8;">起始日期：</p>
               <i-col span="12" class="rightSelect">
                 <Date-picker type="date" v-model="startDate" placeholder="起始日期" @on-change="onDate" style="width: 200px"></Date-picker>
               </i-col>
            </FormItem>
        </Form>
        <Form :label-width="100">
            <FormItem  >
                <p  style="color:#28EDF8;">结束日期：</p>
                <i-col span="12" class="rightSelect">
                    <Date-picker type="date" v-model="endDate"  placeholder="结束日期" @on-change="onDate" style="width: 200px;display:inline-block;"></Date-picker>
                </i-col>
            </FormItem>
        </Form>
        <!--<Form :label-width="100">-->
            <!--<FormItem label="传感器：">-->
                <!--<Select  v-model="device.deviceName" label-in-value @on-change="onSelect" class="rightSelect">-->
                    <!--<Option v-for="item in list" :value="item.deviceName" :key="item.deviceName">{{ item.deviceName }}</Option>-->
                <!--</Select>-->
            <!--</FormItem>-->
        <!--</Form>-->
        <div v-if="list.length <= 0"
             style=" height:calc(100vh - 200px); font-size: 14px; color:#ddd; display: flex; align-items: center; justify-content: center">
            <div style="line-height: 180%; text-align: center">
                <Icon style="font-size: 50px; color:#ddd" type="ios-paper-plane-outline"/>
                <br/>暂无数据
            </div>
        </div>
        <div v-else  :id="index" v-for="(item,index) in list" :key="index" style="width:100%;height: 450px;margin-top: 15px"></div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    // string 转 object JSON.parse(obj)
    // object 转 string JSON.stringify(str)

    export default {

        data() {
            return {
                jxDatas:[],
                // 统计图对象数组
                exampleChart: [],
                startDate:'2019-05-15',
                endDate:'2019-05-16',

                list: [],
                eqls:[],

            };
        },
        computed: {
            areaId(){
                return this.$store.state.app.areaId
            }
        },
        watch:{
            areaId(){
                this.getData();
            }
        },
        created(){
            var that = this;
            //默认显示一天
            that.endDate=new Date();
            var y = that.endDate.getFullYear();
            var m = that.endDate.getMonth()+1;
            var d = that.endDate.getDate()-1;
            if(m<10) {
                m="0"+m;
            }
            if(d<10) {
                d="0"+d;
            }
            that.startDate=y+'-'+m+'-'+d;
            this.getData();

        },
        methods: {
            drawExampleChart: function (item,eqls,index) {
                const that = this;
                that.exampleChart[index] = echarts.init(document.getElementById(index));
                // 动态数据的获取及修改
                let option = that.$TzUntil.getRecord(eqls,item.eid,item.factoryType,item.deviceName);
                that.exampleChart[index].setOption(option,true);
            },
            onDate(){
                this.getEqls();
            },

            //获取传感器记录
            getEqls(){
                const that = this;

                //时间格式化
                var startDate=that.$func.formatDate(that.startDate,"yyyy-MM-dd");
                var endDate=that.$func.formatDate(that.endDate,"yyyy-MM-dd");
                var hash=[];
                // 获取不重复的 精讯传感器的精讯mac
                that.list.map(function (item, index) {
                    if (item.factoryType==5 && item.eid.indexOf('sensor')!=-1){
                        if (hash.indexOf(item.deviceMac)==-1){
                            hash.push(item.deviceMac)
                        }
                    }
                });
                //  精讯的组
                hash.map(function(item,index) {
                    that.$func.jx.getSensorEqls(item.deviceMac,startDate,endDate, function (res) {
                        console.log('&&&&&&&&&&精讯&&&&&&&&&');
                        console.log(res);
                        var datas=res;
                        // 不要再排序等操作  index2位置和初始化图表时一致
                        that.list.map(function (item2,index2) {
                            if (item2.deviceMac==item){
                                console.log('非第一个精讯的传感器已经有数据，直接创建'+JSON.stringify(datas))
                                that.drawExampleChart(item2, datas.reverse(), index2);
                            }

                        })
                    }, function () {
//                            that.$func.notice('【'+item.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                    })
                })
                that.list.map(function (item, index){
                    if(item.factoryType==1){//天正
                        that.$func.tz.getDevideEqls(item.deviceMac,startDate,endDate, function (res) {
                            console.log(res);
                            that.drawExampleChart(item,res,index);
                        }, function () {
//                            that.$func.notice('【'+item.deviceName+'】设备接口异常，禁止操作，请联系管理员！','error');
                        })
                    }else  if(item.factoryType==6){
                        that.$func.ajax('listSensorRecord', {
                            startDate: startDate,
                            endDate: endDate,
                            deviceNo: item.deviceId
                        }, function (r) {
                            if (r.statusCode) {//有记录
                                that.drawExampleChart(item, r.type,index);
                            }
                        });
                    }
                })


            },
            //获取传感器数据
            getData(){
                const that = this;
                that.$func.ajax('catList', {
                    catPosition: 3,
                    flag: 1,
                    token: that.$func.getToken(),
                    areaId:that.$store.state.app.areaId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        //偷懒写死 20181217151828yraPJcuH
                        for(let ii = 0; ii < r.type.length; ii++){
                            if(r.type[ii].catId == that.$TzUntil.tzSensorCatId){
                                that.list=r.type[ii].devices
                            }
                        }

                        that.getEqls();
                        console.log('传感器');
                        console.log(that.list);
                    }
                })
            },

        },

    };
</script>